export enum ServiceOffering {
  Blackbox = 0,
  Collections,
  CreditAssessment,
  HybridAppraisal,
  Mandate,
  Sweep
}